export const Wrapper: React.FC = ({ children }) => {
    return <div className="min-vh-100 d-flex flex-column">{children}</div>;
};
